import { Injectable, inject } from '@angular/core';
import { ListenAllNotificationsQuery, ListenAllNotificationsQueryHandler } from '@okcargo/query-processor';
import { BaseServerEventQueryRepository } from './base-server-event-query.repository';

@Injectable({ providedIn: 'root' })
export class ServerEventQueryService {
  private readonly queryRepository = inject(BaseServerEventQueryRepository);

  private readonly listenAllNotificationsQueryHandler = new ListenAllNotificationsQueryHandler(this.queryRepository);

  private isServerEventsListening = false;

  listenServerEvents(): void {
    // only one listener
    if (!this.isServerEventsListening) {
      const query = {} as ListenAllNotificationsQuery;
      this.listenAllNotificationsQueryHandler.handle(query);
      this.isServerEventsListening = true;
    }
  }
}
